/**
 * Validates HH:mm time formats
 * @param translateFn The i18n translation function or a pre-translated error message string
 */
export const timeFormatRule = (translateFn: ((key: string) => string) | string) => {
	return (v: string | null | undefined): boolean | string => {
		if (!v) return true;

		// Matches standard HH:mm layout format (e.g., 12:00 or 08:30)
		const regex = /^[0-3]?[0-9]:[0-5][0-9]$/;

		if (regex.test(v)) return true;

		return typeof translateFn === 'function' ? translateFn('planning_wrong_time_format') : translateFn;
	};
};
